import React, { useState, useEffect, useRef } from 'react';
import './Dashboard.css'; 
import DataUsage from './components/DataUsage';
import InvoiceSummary from './components/InvoiceSummary'
import LastThreeMonths from './components/LastThreeMonths';
import AlertsNotifications from './components/AlertsNotifications';
import GetSupport from './components/GetSupport';
import thumbIcon from '../../../assets/icons/gardenwall/thumb.svg';
import ServiceLevel from './components/ServiceLevel';
import YourPlan from './components/YourPlan';
import InternetConnectHealth from './components/InternetConnectHealth';
import AccountDocuments from './components/AccountDocuments';
import Sidebar from '../Sidebar';
import chatIcon from '../../../assets/icons/gardenwall/chat-right-dots-fill.svg';
import { useAuth } from '../../../contexts/AuthContext';
import axios from 'axios';
import { getScenarioContent, getTemplatePrefix } from '../Constants/paymentScenarios';

const Dashboard = ({ activeData }) => {
  const { token } = useAuth();
  
  const paymentScenario = activeData || null;
  console.log('Received paymentScenario:', paymentScenario);

  // Use constants instead of hardcoded logic
  const scenarioContent = getScenarioContent(paymentScenario);
  const scenarioPrefix = getTemplatePrefix(paymentScenario);

  console.log('Dashboard activeData:', activeData);
  console.log('scenarioPrefix:', scenarioPrefix);

  // State for toggles
  const [toggles, setToggles] = useState({
    stopPaperBill: true,
    invoiceSummary: true,
    lastMonths: true,
    dataUsage: true,
    alerts: true,
    support: true,
    accountdocument: true,
    yourPlan: true,
    internetConnectHealth: true,
    servicelevel: true,
    chat: true,
  });
  const [templates, setTemplates] = useState([]);

  const [blockStates, setBlockStates] = useState({});
  const [supportBlockStates, setSupportBlockStates] = useState({});
  const triggerSaveData = useRef(false);
  const [reloadTemplates, setReloadTemplates] = useState(false);

  const handleBlockStatesChange = (newBlockStates) => {
    setBlockStates(newBlockStates);
    triggerSaveData.current = true;
  };

  const handleSupportBlockStatesChange = (newBlockStates) => {
    setSupportBlockStates(newBlockStates);
    triggerSaveData.current = true;
  };

  // Function to toggle on/off switches
  const handleToggle = (section) => {
    setToggles((prev) => ({ ...prev, [section]: !prev[section] }));
    triggerSaveData.current = true;
  };

  useEffect(() => {
    if (triggerSaveData.current) {
      saveData();
      triggerSaveData.current = false;
    }
  }, [toggles, blockStates, supportBlockStates]);

  // Use template prefix from constants
  const template_name = scenarioPrefix === 'current-payment' 
  ? 'gardenwall-dashboard' 
  : `gardenwall-dashboard-${scenarioPrefix}`;
  
console.log('Template name:', template_name);

  const fetchTemplates = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/templates/list`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${token}`,
          },
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching templates:', error);
      return [];
    }
  };

  useEffect(() => {
    const loadTemplates = async () => {
      const fetchedTemplates = await fetchTemplates();
      setTemplates(fetchedTemplates);
    };

    loadTemplates();
  }, []);

  useEffect(() => {
    if (reloadTemplates) {
      const loadTemplates = async () => {
        const fetchedTemplates = await fetchTemplates();
        setTemplates(fetchedTemplates);
        setReloadTemplates(false);
      };
  
      loadTemplates();
    }
  }, [reloadTemplates]);
  
  useEffect(() => {
    if (templates && templates.length > 0) {
      console.log('Templates updated:', templates);
      const specificTemplate = templates.find(
        (template) => template.template_name === template_name
      );
      if (specificTemplate) {
        try {
          const template_data = JSON.parse(
            JSON.parse(specificTemplate.template)
          );
          setToggles(template_data.toggles);
          setBlockStates(template_data.blockStates);
          setSupportBlockStates(template_data.supportBlockStates);
        } catch (error) {
          console.error('Error parsing template data:', error);
        }
      } else {
        console.log('Specific template not found');
      }
    }
  }, [templates, template_name]);

  const saveData = async () => {
    const formData = new FormData();
    formData.append('template_name', template_name);
    formData.append(
      'template',
      JSON.stringify({
        toggles,
        blockStates,
        supportBlockStates,
        scenarioData: paymentScenario
      })
    );
    
    console.log('Saving template with name:', template_name);

    const urlBase = `${process.env.REACT_APP_BASE_URL}/templates`;
    let url = `${urlBase}/create`;
    let method = 'post';

    if (templates && templates.length > 0) {
      const specificTemplate = templates.find(
        (template) => template.template_name === template_name
      );
      if (specificTemplate && specificTemplate.id) {
        url = `${urlBase}/update/${specificTemplate.id}`;
        method = 'put';
      }
    }

    try {
      const response = await axios({
        method: method,
        url: url,
        data: formData,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${token}`,
        },
      });
      console.log('Response Data:', response.data); 
      if (method === 'post') {
        setReloadTemplates(true);
      }

    } catch (error) {
      console.error('Error saving template:', error);
    }
  };

  return (
    <div className="dashboard">
      <div className="dashboard-main">
        <h1 className="dashboard-header">
          Dashboard – <span className={scenarioContent.headerClass}>{scenarioContent.headerStatus}</span>
        </h1>

        <div className="dashboard-grid">
          {/* Invoice Summary Card */}
          <div
            className={`card col-4 ${!toggles.invoiceSummary ? 'card-disabled' : ''}`}
          >
            <div className="card-header">
              Invoice Summary
              <div
                className="custom-toggle"
                onClick={() => handleToggle('invoiceSummary')}
              >
                <input
                  type="checkbox"
                  checked={toggles.invoiceSummary}
                  readOnly
                />
                <span className="toggle-slider"></span>
              </div>
            </div>
            <InvoiceSummary scenarioData={paymentScenario} />
          </div>

          {/* Last 3 Months Card */}
          <div
            className={`card col-4 ${!toggles.lastMonths ? 'card-disabled' : ''}`}
          >
            <div className="card-header">
              Last 3 months
              <div
                className="custom-toggle"
                onClick={() => handleToggle('lastMonths')}
              >
                <input
                  type="checkbox"
                  checked={toggles.lastMonths}
                  readOnly
                />
                <span className="toggle-slider"></span>
              </div>
            </div>
            <LastThreeMonths scenarioData={paymentScenario} />
          </div>

          {/* Data Usage Card */}
          <div
            className={`card col-4 ${!toggles.dataUsage ? 'card-disabled' : ''}`}
          >
            <div className="card-header">
              Data Usage
              <div
                className="custom-toggle"
                onClick={() => handleToggle('dataUsage')}
              >
                <input type="checkbox" checked={toggles.dataUsage} readOnly />
                <span className="toggle-slider"></span>
              </div>
            </div>
            <DataUsage scenarioData={paymentScenario} />
          </div>

          {/* Your Plan */}
          <div
            className={`card col-4 your-plan ${!toggles.yourPlan ? 'card-disabled' : ''}`}
          >
            <div className="card-header">
              Your Plan
              <div
                className="custom-toggle"
                onClick={() => handleToggle('yourPlan')}
              >
                <input type="checkbox" checked={toggles.yourPlan} readOnly />
                <span className="toggle-slider"></span>
              </div>
            </div>
            <YourPlan scenarioData={paymentScenario} />
          </div>

          {/* Internet Connect Health */}
          <div
            className={`card col-4 internet-health ${!toggles.internetConnectHealth ? 'card-disabled' : ''}`}
          >
            <div className="card-header">
              Internet Connect Health
              <div
                className="custom-toggle"
                onClick={() => handleToggle('internetConnectHealth')}
              >
                <input type="checkbox" checked={toggles.internetConnectHealth} readOnly />
                <span className="toggle-slider"></span>
              </div>
            </div>
            <InternetConnectHealth scenarioData={paymentScenario} />
          </div>

          {/* Get Support Card */}
          <div
            className={`card col-4 get-support ${!toggles.support ? 'card-disabled' : ''}`}
          >
            <div className="card-header">
              Get Support
              <div
                className="custom-toggle"
                onClick={() => handleToggle('support')}
              >
                <input type="checkbox" checked={toggles.support} readOnly />
                <span className="toggle-slider"></span>
              </div>
            </div>
            <GetSupport
              onSupportBlockStatesChange={handleSupportBlockStatesChange}
              supportBlocksEnabled={supportBlockStates}
              scenarioData={paymentScenario}
            />
          </div>

          {/* Service Level */}
          {/*<div
            className={`card col-6 service-level ${!toggles.servicelevel ? 'card-disabled' : ''}`}
          >
            <div className="card-header">
              <span></span>
              <div
                className="custom-toggle"
                onClick={() => handleToggle('servicelevel')}
              >
                <input
                  type="checkbox"
                  checked={toggles.servicelevel}
                  readOnly
                />
                <span className="toggle-slider"></span>
              </div>
            </div>
            <ServiceLevel scenarioData={paymentScenario} />
          </div>*/}

          {/* Chat icon */}
          {/* <div
            className={`card chat-block ${!toggles.chat ? 'card-disabled' : ''}`}
          >
            <div className="card-header">
              <span></span>
              <div
                className="custom-toggle"
                onClick={() => handleToggle('chat')}
              >
                <input type="checkbox" checked={toggles.chat} readOnly />
                <span className="toggle-slider"></span>
              </div>
            </div>
            <span className="chat-icon">
              <img src={chatIcon} alt="Chat Icon" />
            </span>
          </div> */}

          {/* Chat icon */}
<div
  className={`card chat-block ${!toggles.chat ? 'card-disabled' : ''}`}
>
  <div className="card-header">
    <span></span>
  </div>
  <span className="chat-icon">
    <img src={chatIcon} alt="Chat Icon" />
  </span>
</div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

